import get from 'lodash.get';
import actionTypes from 'yola-editor/src/js/modules/user/constants/action-types';
import { AI_CHAT_FEATURE_FLAG } from 'src/js/modules/ai-chat/constants/common';
import operations from '../operations';
import wonderchat from '../wonderchat';
import serviceClient from '../../feature-flags/service-client';
import setHelpCenterIntegration from '../actions/set-help-center-integration';
import integrationTypes from '../constants/integration-types';

const initHelpCenter = (store) => (next) => (action) => {
  const { type, payload } = action;

  next(action);

  if (type !== actionTypes.SET_USER_PARTNER_DATA) {
    return;
  }

  const isWL = get(payload, 'partnerData.isWhiteLabel', true);

  if (!isWL) {
    const featureFlagsManager = serviceClient.get();

    const requestedFlags = ['zendesk_widget', 'wonderchat_widget', AI_CHAT_FEATURE_FLAG];

    featureFlagsManager.request(requestedFlags).then((flags) => {
      const { wonderchat_widget: wonderchatWidget, zendesk_widget: zendeskWidget } = flags;

      if (flags[AI_CHAT_FEATURE_FLAG]) return;

      if (wonderchatWidget) {
        store.dispatch(setHelpCenterIntegration(integrationTypes.WONDERCHAT));
        wonderchat.initChat();
      } else if (zendeskWidget) {
        store.dispatch(setHelpCenterIntegration(integrationTypes.ZENDESK));
        operations.preload();
      }
    });
  }
};

export default initHelpCenter;
